export default __webpack_public_path__ + "static/media/Maidenhair-Fern_L3.936c086e.png";